/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The coordinates of an object on the animatic.
 */
export type Coordinates = {
  /**
   * The x coordinate of the object
   */
  x: number;
  /**
   * The y coordinate of the object
   */
  y: number;
  /**
   * The z coordinate of the object. Not required but useful in case we need to stack objects on top of each other.
   */
  z?: number | undefined;
};

/** @internal */
export const Coordinates$inboundSchema: z.ZodType<
  Coordinates,
  z.ZodTypeDef,
  unknown
> = z.object({
  x: types.number(),
  y: types.number(),
  z: types.optional(types.number()),
});
/** @internal */
export type Coordinates$Outbound = {
  x: number;
  y: number;
  z?: number | undefined;
};

/** @internal */
export const Coordinates$outboundSchema: z.ZodType<
  Coordinates$Outbound,
  z.ZodTypeDef,
  Coordinates
> = z.object({
  x: z.number(),
  y: z.number(),
  z: z.number().optional(),
});

export function coordinatesToJSON(coordinates: Coordinates): string {
  return JSON.stringify(Coordinates$outboundSchema.parse(coordinates));
}
export function coordinatesFromJSON(
  jsonString: string,
): SafeParseResult<Coordinates, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Coordinates$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Coordinates' from JSON`,
  );
}
